import { useEffect, useMemo } from "react";
import PageMeta from "../../components/common/PageMeta";
import WelcomeSection from "./components/WelcomeSection";
import BillingSection from "./components/BillingSection";
import QuickAccessSection from "./components/QuickAccessSection";
import QuickAccessAdminSection from "./components/QuickAccessAdminSection";
import TrendUtilitySection from "./components/TrendUtilitySection";
import RecentActivitySection from "./components/RecentActivitySection";
import SafetyTaskSection from "./components/SafetyTaskSection";
import TenantRequestSection from "./components/TenantRequestSection";
import DocumentLogSection from "./components/DocumentLogSection";
import PromoSliderSection from "./components/PromoSliderSection";
import ExitGoodsPermitSection from "./components/Exitgoodspermitsection";
import EntryGoodsPermitSection from "./components/Entrygoodspermitsection";
import WorkPermitSection from "./components/WorkPermitSection";
import Dropdown from "../../components/dropdown/Index";
import useMallTenantDropdown from "../../hooks/useMallTenantDropdown";
import { triggerTenantChange } from "../../utils/tenantChangeEvent";

const getLoginTenantId = (): number => {
  const stored =
    localStorage.getItem("login_tenant_id") ||
    sessionStorage.getItem("login_tenant_id") ||
    localStorage.getItem("tenant_id") ||
    sessionStorage.getItem("tenant_id");
  return stored ? parseInt(stored, 10) : 0;
};

export default function Home() {
  const loginTenantId = useMemo(() => getLoginTenantId(), []);

  const isHOUser = useMemo(() => {
    const role = localStorage.getItem("role_name") || sessionStorage.getItem("role_name");
    return role?.toUpperCase() === "HO";
  }, []);

  const {
    mallOptions,
    tenantOptions,
    selectedMall,
    selectedTenant,
    setSelectedMall,
    setSelectedTenant,
  } = useMallTenantDropdown(() => {
    triggerTenantChange();
  });

  useEffect(() => {
    if (selectedMall !== null && selectedMall !== undefined) {
      localStorage.setItem("mall_id", String(selectedMall));
      sessionStorage.setItem("mall_id", String(selectedMall));
    }
  }, [selectedMall]);

  return (
    <>
      <PageMeta
        title="Tenant Access — Dashboard"
        description="Overview dashboard for Tenant Access"
      />

      <div className="max-w-full mx-auto px-2 sm:px-3 lg:px-4">
        <div className="flex items-center justify-end gap-3 mb-3">
          <Dropdown
            mallSelected={setSelectedMall}
            mallOptions={mallOptions}
            tenantSelected={setSelectedTenant}
            tenantOptions={tenantOptions}
            mallValue={selectedMall}
            tenantValue={selectedTenant}
          />
        </div>

        {isHOUser || loginTenantId === 0 ? (
          <div className="space-y-0">
            <div className="flex flex-col lg:flex-row gap-5 items-stretch mt-8 mb-8">
              <div className="lg:w-[40%] flex">
                <WelcomeSection selectedTenant={selectedTenant} />
              </div>
              <div className="lg:w-[30%] flex">
                <BillingSection />
              </div>
              <div className="lg:w-[30%] flex">
                <QuickAccessSection />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 items-stretch mb-6">
              <div className="lg:w-[55%] min-w-0">
                <TrendUtilitySection />
              </div>
              <div className="lg:w-[45%] min-w-0">
                <RecentActivitySection />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6 mb-6">
              <div id="safety-task-section" className="rounded-2xl">
                <SafetyTaskSection />
              </div>
              <div id="tenant-request-section" className="rounded-2xl">
                <TenantRequestSection
                  selectedTenant={selectedTenant}
                  selectedMall={selectedMall}
                />
              </div>
              <div id="work-permit-section" className="rounded-2xl">
                <WorkPermitSection />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <ExitGoodsPermitSection />
              <EntryGoodsPermitSection />
            </div>

            <div className="flex flex-col lg:grid lg:grid-cols-12 gap-6">
              <div className="lg:col-span-9 flex flex-col gap-6 h-full">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6"></div>
                <div className="flex-1 min-h-0">
                  <DocumentLogSection />
                </div>
              </div>
              <div className="lg:col-span-3 flex flex-col gap-6">
                <PromoSliderSection />
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <PromoSliderSection horizontal />
            </div>
            <div className="flex flex-col lg:flex-row gap-6 items-stretch">
              <div className="lg:w-[55%] flex-shrink-0">
                <QuickAccessAdminSection />
              </div>
              <div className="lg:w-[45%] min-w-0">
                <DocumentLogSection />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 items-stretch">
              <div className="lg:w-[55%] min-w-0">
                <TrendUtilitySection />
              </div>
              <div className="lg:w-[45%] min-w-0">
                <RecentActivitySection />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div id="safety-task-section" className="rounded-2xl">
                <SafetyTaskSection />
              </div>
              <div id="tenant-request-section" className="rounded-2xl">
                <TenantRequestSection
                  selectedTenant={selectedTenant}
                  selectedMall={selectedMall}
                />
              </div>
              <div id="work-permit-section" className="rounded-2xl">
                <WorkPermitSection />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <ExitGoodsPermitSection />
              <EntryGoodsPermitSection />
            </div>
          </div>
        )}
      </div>
    </>
  );
}